import { FacilitySettingsPage } from '@/pages/facility/settings/component';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute('/facility/settings')({
	component: FacilitySettingsPage,
});
